// Image Imports
import google from "../../assets/img/idx/rmloc/gsearch.webp";
import yahoo from "../../assets/img/idx/rmloc/yahoo.webp";
import bing from "../../assets/img/idx/rmloc/bing.webp";
import duckduckgo from "../../assets/img/idx/rmloc/duckduckgo.webp";
import baidu from "../../assets/img/idx/rmloc/baidu.webp";
import instagram from "../../assets/img/idx/rmloc/instagram.webp";
import youtube from "../../assets/img/idx/rmloc/youtube.webp";
import facebook from "../../assets/img/idx/rmloc/facebook.webp";
import reddit from "../../assets/img/idx/rmloc/reddit.webp";
import twitter from "../../assets/img/idx/rmloc/twitter.webp";
import tiktok from "../../assets/img/idx/rmloc/tiktok.webp";
import pinterest from "../../assets/img/idx/rmloc/pinterest.webp";
import linkedin from "../../assets/img/idx/rmloc/linkedin.webp";
import vimeo from "../../assets/img/idx/rmloc/vimeo.webp";
import blogger from "../../assets/img/idx/rmloc/blogger.webp";
import tumblr from "../../assets/img/idx/rmloc/tumblr.webp";


// Functional Component
export default function RemovalSection() {
  return (
    <div className="section-content removal">
      <h2>Removal</h2>
      <br/>
      <div className="section-group">
        <div className="links-group">
          <h4>We remove...</h4>
          <a href="/remove/images">Images</a>
          <a href="/remove/videos">Videos</a>
          <a href="/remove/search-results">Search Results</a>
          <a href="/remove/websites">Websites</a>
          <a href="/remove/social-media-posts">Social Media Posts</a>
          <a href="/remove/blogs">Blogs</a>
          <a href="/remove/fake-accounts">Fake Accounts</a>
          <a href="/remove/leaked-content">Leaked Content</a>
          {/* <a href="/remove/related-searches">Related Searches</a> */}
        </div>
      </div>
      <br/><br/>
      <div className="section-group">
        <div className="links-group">
          <h4>Search Engines</h4>
          <a href="/remove/google-search-results">
            <img src={google.src} alt="Google" />
            Google
          </a>
          <a href="/remove/yahoo-search-results">
            <img src={yahoo.src} alt="Yahoo" />
            Yahoo
          </a>
          <a href="/remove/bing-search-results">
            <img src={bing.src} alt="Bing" />
            Bing
          </a>
          <a href="/remove/duckduckgo-search-results">
            <img src={duckduckgo.src} alt="DuckDuckGo" />
            DuckDuckGo
          </a>
          <a href="/remove/baidu-search-results">
            <img src={baidu.src} alt="Baidu" />
            Baidu
          </a>
        </div>
        <br/><br/>
        <div className="links-group">
          <h4>Social Media</h4>
          <a href="/remove/instagram-content">
            <img src={instagram.src} alt="Instagram" />
            Instagram
          </a>
          <a href="/remove/youtube-content">
            <img src={youtube.src} alt="YouTube" />
            YouTube
          </a>
          <a href="/remove/facebook-content">
            <img src={facebook.src} alt="Facebook" />
            Facebook
          </a>
          <a href="/remove/reddit-content">
            <img src={reddit.src} alt="Reddit" />
            Reddit
          </a>
          <a href="/remove/x-twitter-content">
            <img className="sm" src={twitter.src} alt="X / Twitter" />
            X / Twitter
          </a>
          <a href="/remove/tiktok-content">
            <img src={tiktok.src} alt="TikTok" />
            TikTok
          </a>
          <a href="/remove/pinterest-content">
            <img src={pinterest.src} alt="Pinterest" />
            Pinterest
          </a>
          <a href="/remove/linkedin-content">
            <img src={linkedin.src} alt="LinkedIn" />
            LinkedIn
          </a>
          <a href="/remove/vimeo-content">
            <img src={vimeo.src} alt="Vimeo" />
            Vimeo
          </a>
          <a href="/remove/blogger-content">
            <img src={blogger.src} alt="Blogger" />
            Blogger
          </a>
          <a href="/remove/tumblr-content">
            <img src={tumblr.src} alt="Tumblr" />
            Tumblr
          </a>
        </div>
      </div>
    </div>
  );
} 